import { Box, Typography } from '@mui/material';
import { forwardRef } from 'react';

export const Tag = forwardRef<
  HTMLSpanElement,
  {
    content: string;
    variant?: 'primary' | 'secondary';
    disabled?: boolean;
  }
>(({ content, variant = 'primary', disabled = false, ...rest }, ref) => {
  // adding typography manually for cases where it's being overridden by accordionSummary
  // once fixing accordionSummary, we can stay with the typography variant (subtitle2/body2)
  const typographySx = {
    color:
      variant === 'secondary' || disabled
        ? 'var(--mui-palette-text-secondary)'
        : 'var(--mui-palette-text-primary)',
    fontWeight: '400 !important',
  };

  return (
    <Box
      {...rest}
      ref={ref}
      width='fit-content'
      className='px-[8px] py-[3px] rounded-[4px] flex-inline vertical-align-middle'
      sx={{
        ...typographySx,
        backgroundColor: disabled
          ? 'var(--mui-palette-background-disabled)'
          : 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: disabled
          ? 'transparent'
          : variant === 'primary'
            ? 'var(--mui-palette-primary-main)'
            : 'var(--mui-palette-divider)',
      }}
    >
      <Typography
        sx={{
          ...typographySx,
        }}
        variant={variant === 'primary' ? 'subtitle2' : 'body2'}
      >
        {content}
      </Typography>
    </Box>
  );
});
